module.exports = __webpack_public_path__ + "img/sirihuodong_icon.56b4aad6.png";